// The CTA vocabulary paywall surfaces are allowed to emit. The API validates
// `cta_id` against a closed set and silently nulls anything outside it, so
// these values must stay in lockstep with the server's CTA_IDS -- they are
// not free-form labels components get to invent.

// plan.id values are `pro`, `basicPlus` and `free`; the analytics vocabulary
// names the middle tier by what users see ("CREATOR"), not by its internal id.
// An explicit map rather than `subscribe_${plan.id}` because the server
// validates cta_id against a closed set and silently nulls anything outside it
// -- a concatenated id fails as missing data, not as an error.
export const CTA_ID_BY_PLAN_ID = {
  pro: 'subscribe_pro',
  basicPlus: 'subscribe_creator'
}

// Only upgrade-offer cards belong in the paywall dataset. BannerItem is a
// shared component that also renders unrelated cards (youtubeRed, "Follow us
// on YouTube"), and banner_impression is an ATTRIBUTABLE event: the last-touch
// attribution query would credit an upgrade to whichever banner the user saw
// most recently, so a social-follow card left in here would steal credit from
// the paywall that actually drove the conversion. Keep `claimDiscount` here
// even though its BannerItems entry is currently commented out -- it is a
// real upgrade offer that can be re-enabled, and its absence from this map
// would be a latent version of this same bug. A key that is not in this map
// (youtubeRed, discord, productHunt, sora2, ...) is not tracked at all: no
// impression, no click.
export const CTA_ID_BY_BANNER_KEY = {
  proTrial: 'start_trial',
  claimDiscount: 'claim_discount',
  pricing: 'learn_more',
  static_banner: 'static_banner'
}
